export default {
	comum: {
		rota: {
			origem: 'Inicial',
		},
		requisicoesPendentes: 0,
		executarSemLoading: false,
		loadingManual: false,
		isSalvamentoAutomaticoErro: false,
		quantidadeRequisicoesSalvamentoAutomatico: 0,
	},
	cabecalhoPadrao: [
		{
			titulo: '',
			subtitulo: {
				texto: '',
			},
		},
	],
	cabecalhoKey: 0,
	campoArquivoNovo: {
		arquivoTemporario: null,
		erroObrigatoriedade: false,
		documentoComAnexo: null,
		documentoSelecionado: null,
		validacaoDocuentoEnviado: false,
	},
	campoEditarNumero: {
		numero: null,
	},
	defaultLoadingMessage: 'Carregando...',
	modalAssinaturaFlowbee: {
		exibir: false,
		documentosSelecionados: [],
	},
	escolherOrgao: {
		modal: {
			exibir: false,
		},
	},
	orgaoLogado: 0,
}
